import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass =
	// eslint-disable-next-line import/no-webpack-loader-syntax
	require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

mapboxgl.accessToken =
	"pk.eyJ1IjoiZXJpa2VsbGlsbyIsImEiOiJja3YwdTNmenAyZHFoMnBwNmhsdTExdmpyIn0.EGS0-8E2QVERqMEa2w4aNg";

export const maps =
	"pk.eyJ1IjoiZXJpa2VsbGlsbyIsImEiOiJja3YwdTNmenAyZHFoMnBwNmhsdTExdmpyIn0.EGS0-8E2QVERqMEa2w4aNg";

export const kordinatKoka = {
	latitude: -6.9662636,
	longitude: 107.6349237,
};

// https://www.google.com/maps/dir/?api=1&destination=Teras+Seduh+Koka,+Jalan+Adhyaksa+Raya,+Sukapura,+Bandung+City,+West+Java/
